import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import 'react-table/react-table.css';
import Table from '../../../common/table/Table';
import { IconDelete, IconEdit, PrimaryIcon } from '../../../common/Button';
import { debounce } from 'throttle-debounce';
import moment from 'moment';
import { fetchTemplateListPageData } from '../../../../actions/admin/actionAdminTemplateListPage';

class ListTemplateTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.loadStateFromSessionStorage({
            listTDefaultPageSize: 10,
            listTDefaultSort: [],
            listTDefaultFilters: [],
        });
        this.filtering = false;

        this.handleFetchData = this.handleFetchData.bind(this);
        this.handleFetchDataDebounced = debounce(1000, this.handleFetchData);
    }

    componentDidMount() {
        window.addEventListener(
            'beforeunload',
            this.saveStateToSessionStorage.bind(this)
        );
    }

    componentWillUnmount() {
        window.removeEventListener(
            'beforeunload',
            this.saveStateToSessionStorage.bind(this)
        );
        this.saveStateToSessionStorage();
    }

    loadStateFromSessionStorage(defaults) {
        return Object.keys(defaults)
            .reduce((acc, key) => {
                if (sessionStorage.hasOwnProperty(key) && key.match(/^listT*/)) {
                    let value = sessionStorage.getItem(key);
                    value = JSON.parse(value);
                    return {
                        ...acc,
                        [key]: value,
                    };
                }
                return acc;
            }, defaults);
    }

    saveStateToSessionStorage() {
        for (let key in this.state) {
            if (key.match(/^listT*/)) {
                sessionStorage.setItem(key, JSON.stringify(this.state[key]));
            }
        }
    }

    handleFetchData = state => {
        this.props.fetchTemplateListPageData(state.page, state.pageSize, state.sorted, this.normalizeFiltered(state));
        this.filtering = false;
        this.setState({
            listTDefaultPageSize: state.pageSize,
            listTDefaultSort: state.sorted,
            listTDefaultFilters: state.filtered
        });
    };

    fetchStrategy = (state) => {
        this.filtering ? this.handleFetchDataDebounced(state) : this.handleFetchData(state);
    };

    normalizeFiltered = state => {
        return state.filtered
            .filter(filterItem => filterItem.value)
            .map(filterItem => {
                if (filterItem.value instanceof Date) {
                    return {
                        id: filterItem.id,
                        value: moment(filterItem.value).add(12, 'hours').toISOString().substr(0, 10)
                    };
                } else {
                    return filterItem;
                }
            });
    };

    render() {
        const { columns, data, pages, isLoading, handleEditClick, handleDeleteClick } = this.props;
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col">
                        <Table
                            columns={[
                                ...columns]}
                            toolButtons={[
                                {
                                    handleClick: handleEditClick,
                                    component: <PrimaryIcon className="btn btn-sm mr-sm-1" title="Edit" type="button"
                                                            key="editButton">
                                        <IconEdit/>
                                    </PrimaryIcon>
                                },
                                {
                                    handleClick: handleDeleteClick,
                                    component: <PrimaryIcon className="btn btn-sm" title="Delete" type="button"
                                                            key="deleteButton">
                                        <IconDelete/>
                                    </PrimaryIcon>
                                }
                            ]}
                            isLoading={isLoading}
                            data={data}
                            pages={pages}
                            handleFetchData={this.fetchStrategy}
                            handleOnFilteredChange={() => {
                                this.filtering = true;
                            }}
                            defaultFiltered={this.state.listTDefaultFilters}
                            defaultSorting={this.state.listTDefaultSort}
                            defaultPageSize={this.state.listTDefaultPageSize}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

ListTemplateTable.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    data: PropTypes.array.isRequired,
    pages: PropTypes.number.isRequired,
    fetchTemplateListPageData: PropTypes.func.isRequired,
    columns: PropTypes.array,
    userRoles: PropTypes.object.isRequired,
    handleEditClick: PropTypes.func.isRequired,
    handleDeleteClick: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    isLoading: state.adminTemplateList.isTableLoading,
    data: state.adminTemplateList.listData,
    pages: state.adminTemplateList.pages,
    userRoles: state.profile.userDetail.roles
});

export default connect(mapStateToProps, {
    fetchTemplateListPageData
})(ListTemplateTable);
